export default __webpack_public_path__ + "static/media/1043.6b4042e7.png";